module.exports = __webpack_public_path__ + "img/Xardoux.d1a5ac21.png";